<template>
  <div class="dialog_box" :style="style">
    <div class="son">
      <div class="close_box"><IconClose @click.native="clickClose" /></div>
      <!-- logo -->
      <div class="dialog_logo" />

      <!-- 二维码 -->
      <div class="qr_box">
        <h3 class="qr_title">微信登录</h3>
        <div class="qr">
          <QrIframe
            v-show="loginUrlWechat" scrolling="no" :height="148" :width="148"
            :url="loginUrlWechat" />
          <div class="wechat_icon" />
        </div>
        <p class="desc">使用微信扫描二维码<strong>注册/登录</strong></p>
      </div>

      <div class="user_agreement_box">
        <p class="font">登录即同意《<a class="agreement" @click="clickUserProtocol">用户协议</a>》</p>
      </div>
      <div class="login_box">
        <div class="login_item_container">
          <div class="login_item qq" @click="clickQQLogin" />
          <p class="login_item_desc">QQ登录</p>
        </div>
        <div v-if="isChannelDuba" class="login_item_container">
          <div class="login_item duba" @click="clickDubaLogin" />
          <p class="login_item_desc">金山毒霸登录</p>
        </div>
        <div class="login_item_container">
          <div class="login_item keniu" @click="clickKeniuLogin" />
          <p class="login_item_desc">可牛办公登录</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import IconClose from '@/components/Icons/IconClose.vue'
import QrIframe from '@/views/Login/QrIframe.vue'

import WeChatAuth from '@/plugins/auth/wechatAuth.js'
import { loginAppType, loginApp } from '@/common/const.js'

import {
  ClientCloseSelf, ClientOpenBrowser, ClientSetUserInfo,
  ClientOpenTabsByQQLogin, ClientLogin, ClientGetDubaInfo, ClientLoginRetain,
  ClientSendMsgToTable
} from '@/api/clientApi.js'
import { urlUserProtocol } from '@/common/resources.js'
import { CacheSessionGetSource, CacheSetLoginType } from '@/common/cache.js'
import api from '@/api'
import { RetCode } from '@/api/bussinessCode.js'
import { reportServerId, reportLoginShow, getAdConfig } from '@/common/business.js'
import { report } from '@/report/index.js'

export default {
  name: 'LoginDialog',

  components: { IconClose, QrIframe },

  data () {
    return {
      loginUrl: '',
      loginUrlWechat: '',
      wechatClass: new WeChatAuth({ isStyle: true }),
      adConfigBg: '',
      queryClientLoginTimeout: null
    }
  },

  computed: {
    dialogPayAbTestType () { // 支付窗abTest类型
      return this.$store.state.dialogPayAbTestType
    },
    style () {
      if (this.adConfigBg) {
        return {
          'background-image': `url(${this.adConfigBg})`
        }
      }
      return {}
    },
    isChannelDuba () {
      return this.$store.getters['channel/isChannelDuba']
    }
  },

  created () {
    this.initAdConfigBg()
    this.loginWechat()
    this.listenMessage()
  },

  beforeDestroy () {
    this.clearQueryClienLogin()
  },

  destroyed () {
    window.removeEventListener('message', this.listenFunc)
  },

  methods: {
    async initAdConfigBg () {
      const posCode = 'officeside_login_pic_wanmei'
      const config = await getAdConfig(posCode)
      this.adConfigBg = config?.img
      if (!this.adConfigBg) {
        this.adConfigBg = require('@/assets/images/bg-login-mid-autumn.png')
      }
    },

    loginWechat () {
      this.loginUrlWechat = this.wechatClass.openAuthPage()
    },

    listenMessage () {
      window.addEventListener('message', this.listenFunc)
    },

    listenFunc (data) {
      if (data.data && typeof data.data === 'string') {
        const newData = JSON.parse(data.data)
        const search = newData.search

        if (!search) { return }

        const searchState = search.state
        const wechatState = this.wechatClass.getState()

        if (!searchState || searchState !== wechatState) { return }

        if (!search.code) { return }
        this.userLogin(search.code) // LoginType第三方接口传过去的参数
      }
    },

    userLogin (code) {
      const params = { login_type: 1, code, login_app: 'chestnutoffice', channel: CacheSessionGetSource() || '' }

      api.user.login({ data: params }).then(res => {
        const data = res.data

        const userType = data?.user_info?.is_new_user === 0 ? 2 : 1 // 默认是新注册

        // 存储userInfo，下一步上报需要
        const userInfo = { token: data.token, ...data.user_info }

        // 为新注册用户，需要上报serverId
        // 上报前需要设置store的token，上报需要token值
        this.$store.commit('vuexSetUserInfo', userInfo)
        if (userType === 1) {
          reportServerId()
        }

        ClientSetUserInfo(userInfo)
        this.getPrivliege(userInfo, userType) // 获取用户权益
      }).catch(() => {
        this.$toast({ desc: '登录异常，请联系客服或关闭重试' })
      })
    },

    clickDubaLogin () {
      this.reportClickDubaLogin()
      this.checkClientInfo()
    },

    /** 上报-点击毒霸登录 */
    reportClickDubaLogin () {
      const params = { actiontype: 'loginclick', actionid: 3, ext: '' }
      report('login', params)
    },

    getPrivliege (userInfo, userType) {
      let privliegeName = ''
      let privliegeEndTime = ''
      let isVip = false

      api.user.privliege({ data: { common: { token: userInfo.token, uid: userInfo.uid } } }).then(pRes => {
        privliegeName = pRes.data.name
        privliegeEndTime = pRes.data.end_date
        isVip = true
      }).catch(data => {
        if (data?.ret && data.ret.toString() in RetCode) {
          privliegeName = RetCode[data.ret]
        }
      }).finally(() => {
        const lastUserInfo = { privliegeName, privliegeEndTime, isVip, ...userInfo }

        // this.reportLogin(8, userType)
        this.$store.commit('vuexSetUserInfo', lastUserInfo)
        ClientSetUserInfo(lastUserInfo)
          .then(() => {
            ClientSendMsgToTable('matDetail', 'logined')
            ClientCloseSelf()
          })
      })
    },

    clickClose () {
      ClientCloseSelf()
      /** 登陆挽留页，兼容开关 */
      getAdConfig('kofficeside_login_outlet').then(res => {
        if (res?.url) {
          ClientLoginRetain()
        }
      })
    },

    clickUserProtocol () { ClientOpenBrowser(urlUserProtocol) },

    clickQQLogin () {
      this.clearQueryClienLogin()
      CacheSetLoginType(loginAppType.wanmei)
      ClientOpenTabsByQQLogin()
    },

    clickKeniuLogin () {
      reportLoginShow()
      this.$store.dispatch('showLoginByChannel')
      ClientCloseSelf()
    },

    getUserInfoByClientInfo (userInfo) {
      // login_type: 3 毒霸
      const req = {
        data: {
          login_type: 3,
          channel: CacheSessionGetSource(),
          login_app: loginApp,
          duba_login_info: {
            svrid: '',
            openid: userInfo.open_id,
            token: userInfo.token
          }
        }
      }
      return api.user.loginThird(req)
        .then(res => {
          const data = res.data
          return { token: data.token, ...data.user_info }
        })
    },

    loginByClientInfo (clientInfo) {
      this.getUserInfoByClientInfo(clientInfo)
        .then((userInfo) => {
          this.getPrivliege(userInfo)
        })
    },

    checkClientInfo () {
      this.getClientUserInfo()
        .then(clientInfo => {
          if (clientInfo) {
            this.loginByClientInfo(clientInfo)
            return
          }
          ClientLogin()
          this.queryClientLogin()
        })
    },

    queryClientLogin () {
      this.getClientUserInfo()
        .then(clientInfo => {
          if (clientInfo) {
            this.loginByClientInfo(clientInfo)
          } else {
            this.queryClientLoginTimeout = setTimeout(() => {
              this.queryClientLogin()
            }, 1000)
          }
        })
    },

    getClientUserInfo () {
      return new Promise(resolve => {
        ClientGetDubaInfo(userInfo => {
          if (userInfo) {
            const isLoginIn = !userInfo.is_logout
            const isNotTourist = !userInfo.is_tourist
            // 登录了并且不是游客才算有用户信息
            if (isLoginIn && isNotTourist) {
              resolve(userInfo)
              return userInfo
            }
          }
          const noUserInfo = null
          resolve(noUserInfo)
          return noUserInfo
        })
      })
    },

    clearQueryClienLogin () {
      clearTimeout(this.queryClientLoginTimeout)
    }
  }
}
</script>

<style lang="scss" scoped>
$color: #4a96e8;

.dialog_box {
  width: 752px;
  height: 454px;
  margin: 6px 0 0 6px;
  background-color: #fff;
  background-repeat: no-repeat;
  box-shadow: $box_shadow_dialog;
  .son { float: right; width: 386px; height: 454px; }

  .close_box { box-sizing: border-box; height: 30px; padding: 10px; overflow: hidden; font-size: 0; text-align: right; }

  .dialog_logo { height: 32px; margin-bottom: 35px; background-image: url(~@/assets/images/logo.png); background-repeat: no-repeat; background-position: center center; background-size: contain; }

  .qr_box { display: flex; flex-direction: column; align-items: center; }
  .qr_title { margin-bottom: 8px; font-size: 16px; font-weight: bold; line-height: 16px; color: #333; }
  .qr {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 148px;
    height: 148px;
    font-size: 12px;
    line-height: 12px;
    color: #fff;

    .wechat_icon { position: absolute; top: 50%; left: 50%; width: 50px; height: 50px; background-image: url(~@/assets/images/icon_dialog_wechat.png); background-size: cover; transform: translate(-50%, -50%); }
  }
  .desc {
    margin: 13px auto 20px auto;
    font-size: 14px;
    font-weight: 400;
    line-height: 14px;
    color: #666;

    strong { font-weight: bold; }
  }

  .user_agreement_box {
    margin-bottom: 20px;
    text-align: center;

   .font { display: inline-block; font-size: 12px; font-weight: 400; line-height: 12px; color: #666; }
   .agreement { color: $color; text-decoration: none; cursor: pointer; }
  }

  .login_box { display: flex; align-items: center; justify-content: center; font-size: 0; }
  .login_item_container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 77px;
    &:not(:first-child) {
      margin-left: 20px;
    }
  }
  .login_item {
    display: inline-block;
    width: 48px;
    height: 48px;
    cursor: pointer;
    &.qq {
      background-image: url(~@/assets/images/icon_dialog_qq.svg);
      background-size: cover;
      &:hover { background-image: url(~@/assets/images/icon_dialog_qq_hover.svg); }
    }
    &.keniu {
      background-image: url(~@/assets/images/icon_to_login_keniu.png);
      &:hover { background-position: 48px; }
    }
    &.duba {
      background-image: url(~@/assets/images/icon_login_duba.png);
      &:hover { background-position: 48px; }
    }
  }
  .login_item_desc { margin-top: 7px; font-size: 12px; line-height: 12px; color: #666; }
}
</style>
